import { Component, OnInit } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';
import { PRIMENG_TRANSLATION } from './components/shared/primeng-translation';
import { NavigationStart, Router } from '@angular/router';
import { MessageService } from './components/shared/message.service';
import { SegurancaService } from '@sigepe/ngx-sigepe-seguranca';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    get title(): string {
        return 'sigepe-ferias';
    }

    constructor(
        private primeConfig: PrimeNGConfig,
        private router: Router,
        private messageService: MessageService,
        private segurancaService: SegurancaService
    ) {}

    ngOnInit(): void {
        this.clearMessages();
        this.primeConfig.setTranslation(PRIMENG_TRANSLATION);

        this.router.events.subscribe({
            next: event => {
                if (event instanceof NavigationStart) {
                    this.messageService.removeOnNavigation();
                }
            }
        });
    }

    sessionTimeFeedback(sessionTime: any) {
        if (sessionTime === 'expired') {
            this.segurancaService.login();
        }
    }

    clearMessages() {
        this.messageService.clear();
    }
}
